//
// Copyright (c) 2024 Comcast
//

import PropTypes from 'prop-types'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import colors from 'components/utils/colors'

import ColorCircle from 'components/Shared/ColorCircle/Index'
import DynamicTextArea from 'components/Shared/DynamicTextArea/Index'

const JustificationWrapper = styled.div`
  background: ${colors.secondary95};
  padding: 4px 12px 12px 12px;
`

const JustificationLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  color: ${colors.secondary20};
  font-family: Exo;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  padding: 4px 0 4px 0;
`

const JustificationInput = ({ value, onChange, showJustification }) => {
  const { t } = useTranslation()

  if (!showJustification) {
    return null
  }

  return (
    <JustificationWrapper>
      <JustificationLabel>
        {t('confirmDialog.justificationLabel')}
        <ColorCircle color={colors.alert} />
      </JustificationLabel>

      <DynamicTextArea
        autoFocus
        small
        minRows={3}
        value={value}
        onChange={onChange}
        placeholder={t('confirmDialog.justificationPlaceholder')}
      />
    </JustificationWrapper>
  )
}

JustificationInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  showJustification: PropTypes.bool,
}

export default JustificationInput
